module.exports = __webpack_public_path__ + "img/tableImg.f06c4dfb.jpg";